import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { LandingScroller } from '../_services/landing-scroller';
import { WebFooter } from '../web-footer/web-footer';
import { WebHeader } from '../web-header/web-header';

/**
 * The frame of the landing pages. The header and footer live here, outside the routed page, so a
 * navigation between pages keeps them: re-created with every page, their colour transitions
 * replayed from the unstyled first render and the header buttons flickered.
 */
@Component({
  selector: 'fr8bot-landing-layout',
  imports: [RouterOutlet, WebHeader, WebFooter],
  templateUrl: './landing-layout.html',
  host: { class: 'tw:block tw:min-w-[300px] tw:overflow-x-hidden' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingLayout {
  constructor() {
    // The router skips `anchorScrolling` for the navigation that hydrates a prerendered page, so a
    // full load of `/shippers#services` (a fresh tab, a refresh) would stay at the top.
    const fragment = inject(ActivatedRoute).snapshot.fragment;

    if (fragment) {
      inject(LandingScroller).scrollToWhenStable(fragment);
    }
  }
}
